import React from 'react';
import { SectionHeading } from './SectionHeading';
const items = [{
  emoji: '📦',
  label: 'Carton',
  tone: 'bg-coral-light'
}, {
  emoji: '🧴',
  label: 'Bouteilles',
  tone: 'bg-sky-light'
}, {
  emoji: '✂️',
  label: 'Ciseaux',
  tone: 'bg-sunshine-light'
}, {
  emoji: '🖊️',
  label: 'Stylos',
  tone: 'bg-brand-light'
}, {
  emoji: '🔧',
  label: 'Ruban adhésif',
  tone: 'bg-mint-light'
}, {
  emoji: '🪩',
  label: 'Bouchons',
  tone: 'bg-coral-light'
}];
export function Materials() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-106" data-mp="1v55ntfg5477p">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-107" data-mp="1v6qhl2umrm4i">
        <SectionHeading eyebrow="🛒 Ce dont vous avez besoin" title={<>De simples objets du quotidien</>} subtitle="Pas de kit de robotique. Pas de pièces coûteuses. Seulement des objets que vous avez déjà." data-id="element-108" data-mp="1qdxcgdv92brw" />
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-6" data-id="element-109" data-mp="xp8hkwksf2ol">
          {items.map(it => <div key={it.label} className={`flex flex-col items-center gap-3 rounded-2xl border border-ink/10 px-4 py-8 text-center ${it.tone}`} data-id="element-110" data-mp="10s7wgbf2xywf">
              <span className="text-4xl" aria-hidden="true" data-id="element-111" data-mp="1akx5kzn5r0ol">
                {it.emoji}
              </span>
              <span className="text-sm font-semibold text-ink" data-id="element-112" data-mp="1entneo4visrh">{it.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}